import { Component, Vue, Watch } from 'vue-property-decorator';
import { isLoggedIn } from '@/state/Authentication';
@Component
export default class default_1 extends Vue {
    get isLoggedIn() {
        return isLoggedIn();
    }
    @Watch('isLoggedIn')
    handleLogin(value) {
        if (value) {
            this.$router.push('/');
        }
    }
}
